//import axios from 'axios'

const state = {
  corsi: [],
  seminari: [],
  letture: [],
  limiti: {
    corsi: { min: 0, max: 999 },
    seminari: { min: 0, max: 999 },
    letture: { min: 0, max: 999 },
  },
};
const getters = {
  totaleCorsiScelti: (state) => {
   // if (state.corsi.length==undefined) {
    
    //return 0;
    //}
    //else
    //{
      return state.corsi.length
    //}
  },
  totaleSeminariScelti: (state) => {
    //if (isNaN(state.corsi.length)) {
    let totaleCorsi =
      state.seminari.length;
    return totaleCorsi;
    //}
    //else
    //{return state.corsi.corsi.lenth}
  },
  totaleLettureScelti: (state) => {
    //if (isNaN(state.corsi.length)) {
    let totaleCorsi =
      state.letture.length;
    return totaleCorsi;
    //}
    //else
    //{return state.corsi.corsi.lenth}
  },
};
const actions = {
  async insertCorso({ commit }, payload) {
    await commit("aggiungiCorso", payload);
  },
};
const mutations = {
  aggiungiCorso: (state, dati) => {
    state[dati.tabella].push(dati.dati);
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
